/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HibernationSchedule } from '../models';
// @ts-ignore
import type { HibernationScheduleUpdate } from '../models';
// @ts-ignore
import type { ListHibernationSchedulesResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * HibernationSchedulesAPIApi - axios parameter creator
 * @export
 */
export const HibernationSchedulesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create hibernation schedule
         * @summary Create a hibernation schedule.
         * @param {string} organizationId ID of the organization that the hibernation job is for
         * @param {HibernationSchedule} hibernationSchedule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPICreateHibernationSchedule: async (organizationId: string, hibernationSchedule: HibernationSchedule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationSchedulesAPICreateHibernationSchedule', 'organizationId', organizationId)
            // verify required parameter 'hibernationSchedule' is not null or undefined
            assertParamExists('hibernationSchedulesAPICreateHibernationSchedule', 'hibernationSchedule', hibernationSchedule)
            const localVarPath = `/cluster-autoscaler/v1beta/organizations/{organizationId}/hibernation-schedules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hibernationSchedule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete hibernation schedule
         * @summary Delete a hibernation schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the hibernation schedule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIDeleteHibernationSchedule: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationSchedulesAPIDeleteHibernationSchedule', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hibernationSchedulesAPIDeleteHibernationSchedule', 'id', id)
            const localVarPath = `/cluster-autoscaler/v1beta/organizations/{organizationId}/hibernation-schedules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get hibernation schedule
         * @summary Get a hibernation schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the hibernation schedule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIGetHibernationSchedule: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationSchedulesAPIGetHibernationSchedule', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hibernationSchedulesAPIGetHibernationSchedule', 'id', id)
            const localVarPath = `/cluster-autoscaler/v1beta/organizations/{organizationId}/hibernation-schedules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the list of organization hibernation schedules  Max page limit is 500.
         * @summary List hibernation schedules.
         * @param {string} organizationId Organization ID
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIListHibernationSchedules: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationSchedulesAPIListHibernationSchedules', 'organizationId', organizationId)
            const localVarPath = `/cluster-autoscaler/v1beta/organizations/{organizationId}/hibernation-schedules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update hibernation schedule
         * @summary Update a hibernation schedule.
         * @param {string} organizationId ID of the organization that the hibernation job is for
         * @param {string} id The ID of the hibernation schedule.
         * @param {HibernationScheduleUpdate} hibernationScheduleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIUpdateHibernationSchedule: async (organizationId: string, id: string, hibernationScheduleUpdate: HibernationScheduleUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('hibernationSchedulesAPIUpdateHibernationSchedule', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hibernationSchedulesAPIUpdateHibernationSchedule', 'id', id)
            // verify required parameter 'hibernationScheduleUpdate' is not null or undefined
            assertParamExists('hibernationSchedulesAPIUpdateHibernationSchedule', 'hibernationScheduleUpdate', hibernationScheduleUpdate)
            const localVarPath = `/cluster-autoscaler/v1beta/organizations/{organizationId}/hibernation-schedules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hibernationScheduleUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HibernationSchedulesAPIApi - functional programming interface
 * @export
 */
export const HibernationSchedulesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HibernationSchedulesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Create hibernation schedule
         * @summary Create a hibernation schedule.
         * @param {string} organizationId ID of the organization that the hibernation job is for
         * @param {HibernationSchedule} hibernationSchedule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationSchedulesAPICreateHibernationSchedule(organizationId: string, hibernationSchedule: HibernationSchedule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationSchedulesAPICreateHibernationSchedule(organizationId, hibernationSchedule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationSchedulesAPIApi.hibernationSchedulesAPICreateHibernationSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete hibernation schedule
         * @summary Delete a hibernation schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the hibernation schedule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationSchedulesAPIDeleteHibernationSchedule(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationSchedulesAPIDeleteHibernationSchedule(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationSchedulesAPIApi.hibernationSchedulesAPIDeleteHibernationSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get hibernation schedule
         * @summary Get a hibernation schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} id The ID of the hibernation schedule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationSchedulesAPIGetHibernationSchedule(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationSchedulesAPIGetHibernationSchedule(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationSchedulesAPIApi.hibernationSchedulesAPIGetHibernationSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the list of organization hibernation schedules  Max page limit is 500.
         * @summary List hibernation schedules.
         * @param {string} organizationId Organization ID
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationSchedulesAPIListHibernationSchedules(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHibernationSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationSchedulesAPIListHibernationSchedules(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationSchedulesAPIApi.hibernationSchedulesAPIListHibernationSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update hibernation schedule
         * @summary Update a hibernation schedule.
         * @param {string} organizationId ID of the organization that the hibernation job is for
         * @param {string} id The ID of the hibernation schedule.
         * @param {HibernationScheduleUpdate} hibernationScheduleUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hibernationSchedulesAPIUpdateHibernationSchedule(organizationId: string, id: string, hibernationScheduleUpdate: HibernationScheduleUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HibernationSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hibernationSchedulesAPIUpdateHibernationSchedule(organizationId, id, hibernationScheduleUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HibernationSchedulesAPIApi.hibernationSchedulesAPIUpdateHibernationSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HibernationSchedulesAPIApi - factory interface
 * @export
 */
export const HibernationSchedulesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HibernationSchedulesAPIApiFp(configuration)
    return {
        /**
         * Create hibernation schedule
         * @summary Create a hibernation schedule.
         * @param {HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPICreateHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationSchedule> {
            return localVarFp.hibernationSchedulesAPICreateHibernationSchedule(requestParameters.organizationId, requestParameters.hibernationSchedule, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete hibernation schedule
         * @summary Delete a hibernation schedule.
         * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIDeleteHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.hibernationSchedulesAPIDeleteHibernationSchedule(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get hibernation schedule
         * @summary Get a hibernation schedule.
         * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIGetHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationSchedule> {
            return localVarFp.hibernationSchedulesAPIGetHibernationSchedule(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of organization hibernation schedules  Max page limit is 500.
         * @summary List hibernation schedules.
         * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIListHibernationSchedules(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHibernationSchedulesResponse> {
            return localVarFp.hibernationSchedulesAPIListHibernationSchedules(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Update hibernation schedule
         * @summary Update a hibernation schedule.
         * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hibernationSchedulesAPIUpdateHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<HibernationSchedule> {
            return localVarFp.hibernationSchedulesAPIUpdateHibernationSchedule(requestParameters.organizationId, requestParameters.id, requestParameters.hibernationScheduleUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for hibernationSchedulesAPICreateHibernationSchedule operation in HibernationSchedulesAPIApi.
 * @export
 * @interface HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationScheduleRequest
 */
export interface HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationScheduleRequest {
    /**
     * ID of the organization that the hibernation job is for
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationSchedule
     */
    readonly organizationId: string

    /**
     * 
     * @type {HibernationSchedule}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationSchedule
     */
    readonly hibernationSchedule: HibernationSchedule
}

/**
 * Request parameters for hibernationSchedulesAPIDeleteHibernationSchedule operation in HibernationSchedulesAPIApi.
 * @export
 * @interface HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationScheduleRequest
 */
export interface HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the hibernation schedule.
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationSchedule
     */
    readonly id: string
}

/**
 * Request parameters for hibernationSchedulesAPIGetHibernationSchedule operation in HibernationSchedulesAPIApi.
 * @export
 * @interface HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationScheduleRequest
 */
export interface HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the hibernation schedule.
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationSchedule
     */
    readonly id: string
}

/**
 * Request parameters for hibernationSchedulesAPIListHibernationSchedules operation in HibernationSchedulesAPIApi.
 * @export
 * @interface HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedulesRequest
 */
export interface HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedulesRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedules
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedules
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedules
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for hibernationSchedulesAPIUpdateHibernationSchedule operation in HibernationSchedulesAPIApi.
 * @export
 * @interface HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationScheduleRequest
 */
export interface HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationScheduleRequest {
    /**
     * ID of the organization that the hibernation job is for
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the hibernation schedule.
     * @type {string}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationSchedule
     */
    readonly id: string

    /**
     * 
     * @type {HibernationScheduleUpdate}
     * @memberof HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationSchedule
     */
    readonly hibernationScheduleUpdate: HibernationScheduleUpdate
}

/**
 * HibernationSchedulesAPIApi - object-oriented interface
 * @export
 * @class HibernationSchedulesAPIApi
 * @extends {BaseAPI}
 */
export class HibernationSchedulesAPIApi extends BaseAPI {
    /**
     * Create hibernation schedule
     * @summary Create a hibernation schedule.
     * @param {HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationSchedulesAPIApi
     */
    public hibernationSchedulesAPICreateHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPICreateHibernationScheduleRequest, options?: RawAxiosRequestConfig) {
        return HibernationSchedulesAPIApiFp(this.configuration).hibernationSchedulesAPICreateHibernationSchedule(requestParameters.organizationId, requestParameters.hibernationSchedule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete hibernation schedule
     * @summary Delete a hibernation schedule.
     * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationSchedulesAPIApi
     */
    public hibernationSchedulesAPIDeleteHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIDeleteHibernationScheduleRequest, options?: RawAxiosRequestConfig) {
        return HibernationSchedulesAPIApiFp(this.configuration).hibernationSchedulesAPIDeleteHibernationSchedule(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get hibernation schedule
     * @summary Get a hibernation schedule.
     * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationSchedulesAPIApi
     */
    public hibernationSchedulesAPIGetHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIGetHibernationScheduleRequest, options?: RawAxiosRequestConfig) {
        return HibernationSchedulesAPIApiFp(this.configuration).hibernationSchedulesAPIGetHibernationSchedule(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the list of organization hibernation schedules  Max page limit is 500.
     * @summary List hibernation schedules.
     * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationSchedulesAPIApi
     */
    public hibernationSchedulesAPIListHibernationSchedules(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIListHibernationSchedulesRequest, options?: RawAxiosRequestConfig) {
        return HibernationSchedulesAPIApiFp(this.configuration).hibernationSchedulesAPIListHibernationSchedules(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update hibernation schedule
     * @summary Update a hibernation schedule.
     * @param {HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HibernationSchedulesAPIApi
     */
    public hibernationSchedulesAPIUpdateHibernationSchedule(requestParameters: HibernationSchedulesAPIApiHibernationSchedulesAPIUpdateHibernationScheduleRequest, options?: RawAxiosRequestConfig) {
        return HibernationSchedulesAPIApiFp(this.configuration).hibernationSchedulesAPIUpdateHibernationSchedule(requestParameters.organizationId, requestParameters.id, requestParameters.hibernationScheduleUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

